import { useCallback } from 'react';

const DEMO_NAMES: Set<string> = new Set([
  'AI feedback for interactive prototypes: How to create your first challenge',
  'Spotify - Onboarding (Velocity Demo)',
  'Netflix - Login (Velocity Demo)',
]);

export const usePrototypeWhitelist = () => {
  const getMatchedDemoName = useCallback((name: string): string | null => {
    for (const demoName of DEMO_NAMES) {
      if (name.includes(demoName)) {
        return demoName;
      }
    }

    return null;
  }, []);

  const getAll = useCallback((): Set<string> => {
    return DEMO_NAMES;
  }, []);

  return {
    getMatchedDemoName,
    getAll,
  };
};
